import { ELE } from 'common/config/enum'
import { cloneDeep } from 'lodash'

export default (boxLabelRetList) => {
  let _boxLabelRetList = cloneDeep(boxLabelRetList)
  _boxLabelRetList?.forEach((box) => {
    (box.finalLabelArray || []).forEach((label) => {
      if (label.type === 1 && label.tag) { // 二级存在
        box[ELE[label.type]] = label.tag
        return
      }
      if (label.type === 314) {
        box[ELE[label.type]] = box[ELE[label.type]] || label.tag // 有314但存在二级则不给一级
        return
      }
      if (!box[ELE[label.type]]) { box[ELE[label.type]] = [] }
      const leaf = box[ELE?.[label.type]].find(m => (m.rootTag === label.rootTag))
      if (leaf && label.type !== 2) {
        leaf.tag = `${leaf.tag},${label.tag}`
        return
      }
      box[ELE[label.type]].push(label)
    })
  })
  _boxLabelRetList = _boxLabelRetList?.filter(label => label.category)
  return _boxLabelRetList
}
